import React, { useState } from "react";
import { Add } from "../Icons/Interface";
import SimpleButton from "../Input/SimpleButton";
import {
	Menu,
	MenuBadge,
	MenuContainer,
	MenuItemElement,
	MenuAlignment,
	MenuDirection
} from "./Menu"; // Import the updated component
import { ActionItem, voidFunc } from "./Actionitem";
import { toTitleCase } from "../../../Utilities/ToTitleCase";

interface TrackMenuProps<T> {
	onStatusChange?: (isOpen: boolean) => void;
	badgeClass?: string;
	menuClass?: string;
	itemClass?: string;
	alignment?: MenuAlignment;
	direction?: MenuDirection;
	actionList: ActionItem<T>[];
}

export const TrackMenu: React.FC<TrackMenuProps<voidFunc>> = ({
	onStatusChange = (isOpen: boolean) => {},
	badgeClass = "bg-primary-background border-primary-active border text-primary rounded-full px-4",
	menuClass = "bg-primary-background space-y-2 rounded-2xl border border-primary-active w-36 overflow-clip",
	itemClass = "text-primary-active hover:bg-primary-accent px-3 py-2 first:rounded-t-2xl last:rounded-b-2xl",
	alignment = "right",
	direction = "below",
	actionList
}) => {
	const [, /*isOpenA*/ setIsOpenA] = useState(false);

	return (
		<Menu
			onClickMenu={(func: voidFunc) => func()}
			onStatus={(isOpen: boolean) => {
				onStatusChange(isOpen);
				setIsOpenA(isOpen);
			}}
		>
			<MenuBadge
				className={`flex items-center`}
				align={alignment}
				direction={direction}
			>
				<SimpleButton className={badgeClass}>
					<div>{Add()}</div>
					<p>Track</p>
				</SimpleButton>
			</MenuBadge>
			<MenuContainer className={menuClass}>
				{actionList.map((item: ActionItem<voidFunc>, index) => (
					<MenuItemElement
						key={index}
						itemKey={item.actionFunc}
						className={itemClass}
					>
						<p>{toTitleCase(item.actionText)}</p>
					</MenuItemElement>
				))}
			</MenuContainer>
		</Menu>
	);
};
